import { render, staticRenderFns } from "./tag-widget.vue?vue&type=template&id=ce15339c&scoped=true"
import script from "./tag-widget.vue?vue&type=script&lang=js"
export * from "./tag-widget.vue?vue&type=script&lang=js"
import style0 from "./tag-widget.vue?vue&type=style&index=0&id=ce15339c&lang=css"
import style1 from "./tag-widget.vue?vue&type=style&index=1&id=ce15339c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce15339c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce15339c')) {
      api.createRecord('ce15339c', component.options)
    } else {
      api.reload('ce15339c', component.options)
    }
    module.hot.accept("./tag-widget.vue?vue&type=template&id=ce15339c&scoped=true", function () {
      api.rerender('ce15339c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/tag-widget.vue"
export default component.exports